"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealGlutenFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealGlutenFilled = function MealGlutenFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.423 16.396c.4.671.695 1.325.886 1.963l.11-.135.268-.305a.197.197 0 01.232-.026l.05.04.254.291c1.732 2.028 2.598 3.915 2.598 5.662 0 1.553-.685 2.753-2.055 3.597l2.876 2.877a1 1 0 01-1.414 1.414l-2.878-2.878c-.844 1.374-2.045 2.062-3.6 2.062-1.747 0-3.635-.866-5.662-2.599l-.305-.267a.197.197 0 01-.027-.232l.041-.05.29-.254.14-.115a8.781 8.781 0 01-1.963-.886l10.159-10.16zm5.272-8.103a1 1 0 010 1.414L10.482 30.92a1 1 0 01-1.414-1.414L30.28 8.293a1 1 0 011.414 0zm-16.916-.16l.063.015.352.157c2.03.924 3.47 2.016 4.318 3.275.1-.188.208-.379.322-.572l.21-.346a.197.197 0 01.224-.067l.056.031.3.243c1.197.986 2.097 1.976 2.7 2.97l-9.617 9.616c-.994-.602-1.984-1.502-2.97-2.698l-.254-.317a.197.197 0 01.014-.233l.049-.042.33-.2c.193-.113.384-.221.573-.323-1.26-.847-2.351-2.286-3.276-4.316l-.163-.37a.197.197 0 01.074-.222l.058-.028.37-.107c.502-.14.985-.251 1.45-.335-.944-1.234-1.506-2.996-1.686-5.288l-.026-.404a.197.197 0 01.145-.184l.064-.006.385.026c2.292.18 4.055.741 5.289 1.684.083-.463.195-.946.334-1.448l.113-.389a.197.197 0 01.2-.122z",
    fill: "#97BA1E"
  }));
};

exports.MealGlutenFilled = MealGlutenFilled;
var _default = MealGlutenFilled;
exports.default = _default;